// Shared by the blog and case studies listing pages. imageName matches a file in src/assets.
// date is when the piece was published or last substantially refreshed; listings sort on it, newest first.
// published is the original publish date, only needed when it differs from date. Both feed the structured data.
const articles = [
    {
        client: "Riley",
        tags: ['Design', 'Development', 'B2B', 'Integrations'],
        blurb: "How we built Riley's subscription-first D2C store and B2B wholesale portal on Shopify Plus, with a custom Klaviyo integration for D2C and HubSpot and Xero automation that saves a day a week.",
        imageName: "riley-hero",
        link: '/case-studies/riley/',
        type: 'Case Study',
        date: '2026-10-15'
    },
    {
        client: "Beyond Nine",
        tags: ['Design', 'Development', 'SEO', 'CRO', 'Analytics'],
        blurb: "Discover how Beyond Nine transformed their Shopify store with a custom redesign, improving site speed by 57%, and increased revenue per user by 26%.",
        imageName: "spring-2025",
        link: '/case-studies/beyond-nine/',
        type: 'Case Study',
        published: '2025-02-19',
        date: '2026-10-14'
    },
    {
        client: "Can you rely on Shopify's tracking alone?",
        tags: ['Analytics'],
        blurb: "When is Shopify's native tracking not enough? We're exploring the pros and cons of using Shopify's native tracking vs a custom integration of your own.",
        imageName: "shopify-live-view-dashboard",
        link: '/blog/can-you-rely-on-shopify-tracking-alone/',
        type: 'Article',
        date: '2025-08-19'
    },
    {
        client: "How to Budget for Your E-Commerce Website: 5 Key Cost Factors",
        tags: ['Design', 'Development', 'SEO'],
        blurb: "Planning your e-commerce website budget? Discover the 5 key cost factors—from platform choice to SEO—that will impact your ROI and long-term growth.",
        imageName: "ecommerce-website-budget-guide",
        link: '/blog/ecommerce-website-budget-guide/',
        type: 'Article',
        date: '2025-02-07'
    },
    {
        client: "Jubel",
        tags: ['Design', 'Development', 'SEO'],
        blurb: "How 54 Bit Studios helped Jubel optimise their website for scalability, performance and enhanced customer engagement.",
        imageName: "jubel-beer",
        link: '/case-studies/jubel/',
        type: 'Case Study',
        published: '2024-11-26',
        date: '2026-10-14'
    },
    {
        client: "When to invest in a new website",
        tags: ['Design', 'Development', 'SEO', 'CRO', 'Analytics'],
        blurb: "Investing in a new website is not as daunting as you may think. In this post, we’re sharing the key factors you should know.",
        imageName: "when-to-invest-in-a-new-website",
        link: '/blog/when-to-invest-in-a-new-website/',
        type: 'Article',
        date: '2024-12-18'
    },
    {
        client: "Black Friday is around the corner, is your Shopify store ready?",
        tags: ['CRO', 'SEO'],
        blurb: "Black Friday is just around the corner, are you ready? We've put together a list of things you can do to prepare your Shopify store for the busiest shopping period of the year.",
        imageName: "black-friday-sign",
        link: '/blog/black-friday-is-around-the-corner-is-your-shopify-store-ready/',
        type: 'Article',
        date: '2024-11-25'
    },
    {
        client: "Russell & Atwell",
        tags: ['Design', 'Development', 'SEO', 'CRO'],
        blurb: "How 54 Bit Studios helped Russell & Atwell elevate their website for faster speed, improved efficiency, and a seamless customer experience.",
        imageName: "chocolates",
        link: '/case-studies/russell-and-atwell/',
        type: 'Case Study',
        date: '2024-11-14'
    },
    {
        client: "Black Friday: Shopify Checklist and Tips",
        tags: ['Development', 'CRO', 'SEO'],
        blurb: "Discover our last minute must-dos to ensure ecommerce success for your Shopify Plus store this Black Friday.",
        imageName: "speed-report",
        link: '/blog/black-friday-shopify-checklist-and-tips/',
        type: 'Article',
        date: '2024-10-23'
    },
    {
        client: "Unlock 25% More Sales This Black Friday",
        tags: ['Development', 'CRO', 'SEO'],
        blurb: "Discover essential Shopify optimisations to boost website speed, mobile usability, checkout efficiency and more to capitalise on Black Friday.",
        imageName: "black-friday",
        link: '/blog/unlock-25-more-sales-this-black-friday-the-ultimate-shopify-optimisation-guide/',
        type: 'Article',
        date: '2024-11-12'
    },
    {
        client: "COAT Paints",
        tags: ['Development', 'SEO', 'Analytics'],
        blurb: "How 54 Bit Studios transformed the COAT Paints website to boost conversion rates and meet the demands of their rapidly expanding customer base.",
        imageName: "coat-tins",
        link: '/case-studies/coat-paints/',
        type: 'Case Study',
        published: '2024-10-05',
        date: '2026-10-14'
    },
    {
        client: "Custom vs Off-the-shelf Shopify Themes: The pros and cons",
        tags: ['Development', 'Design', 'SEO'],
        blurb: "Are off-the-shelf Shopify Themes or custom websites right for you? Discover the pros and cons to help you make an informed decision.",
        imageName: "off-the-shelf",
        link: '/blog/off-the-shelf-shopify-themes-the-pros-and-cons/',
        type: 'Article',
        date: '2024-09-24'
    }
]

// Newest first, with the displayed year taken from the date. Same-day entries keep their order above.
export const withImages = (articles, data) => [...articles]
    .sort((a, b) => b.date.localeCompare(a.date))
    .map(article => ({
        ...article,
        year: article.date.slice(0, 4),
        image: data.allFile.nodes.find(node => node.name === article.imageName)?.childImageSharp?.gatsbyImageData ?? null,
    }));

export default articles;
